export default "__VITE_ASSET__250FPzgu__"